"use strict";

var productTile = require("purina_core/productList/productTile");

// Store teaser HTML for restoration when navigating back to page 1
var teaserStore = {};

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $(".refinement.active").each(function () {
        $(this).removeClass("active");
        var activeDiv = $results.find("." + $(this)[0].className.replace(/ /g, "."));
        activeDiv.addClass("active");
        activeDiv.find("button.title").attr("aria-expanded", "true");
    });

    updateDom($results, ".refinements");

    $("div.refinements li").each(function() {
        if ($(this).find("button i").hasClass("fa-check-square")) {
            var refinementDiv = $(this).closest("div.refinement");
            refinementDiv.addClass("active");
            refinementDiv.find("button.title").attr("aria-expanded", "true");
        }
    });
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        ".refinements": handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        ".grid-header",
        ".header-bar",
        ".header.page-title",
        ".product-grid",
        ".show-more",
        ".filter-bar",
        ".results-count"
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data("url");
    $.ajax({
        url: showMoreUrl,
        method: "GET",
        success: function (response) {
            $target.append(response);
            // initialize product tile custom js functionality
            productTile.init();
        },
        error: function () {
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $("<div>").append($(response));
    var sortOptions = $tempDom.find(".grid-footer").data("sort-options").options;
    sortOptions.forEach(function (option) {
        $("option." + option.id).val(option.url);
    });
}

/**
 * Capture teaser tile HTML on initial page load
 * Stores each teaser by its position for later restoration
 *
 * @return {undefined}
 */
function captureTeasers() {
    $('.teaser-tile').each(function() {
        var $teaser = $(this);
        var position = $teaser.data('teaser-position');
        
        if (position) {
            // Store the entire outer HTML of the teaser region
            teaserStore[position] = {
                html: $teaser[0].outerHTML
            };
        }
    });
}

/**
 * Restore teaser tiles from stored HTML
 * Called when navigating back to page 1 via AJAX
 *
 * @return {undefined}
 */
function restoreTeasers() {
    $('.teaser-placeholder').each(function() {
        var $placeholder = $(this);
        var position = $placeholder.data('teaser-position');
        
        if (teaserStore[position]) {
            // Replace placeholder with the stored teaser HTML
            $placeholder.replaceWith(teaserStore[position].html);
        }
    });
}

/**
 * Check if teasers should be shown based on URL parameters
 * Teasers only show on first page with no sorting or refinements
 *
 * @param {string} url - The URL to check
 * @return {boolean} - True if teasers should be shown
 */
function isFirstPage(url) {
    if (!url) return false;
    
    var urlParams = new URLSearchParams(url.split('?')[1] || '');
    
    // Check if it's the first page
    var startParam = urlParams.get('start');
    var isFirst = !startParam || startParam === '0' || startParam === 0;
    
    if (!isFirst) return false;
    
    // Check for custom sorting (srule parameter present means sorting is applied)
    var hasCustomSorting = urlParams.has('srule');
    
    // Check for refinements
    var hasRefinements = urlParams.has('pmin') || 
                         urlParams.has('pmax') || 
                         urlParams.has('prefn1') ||
                         urlParams.has('preferences');
    
    // Teasers should only show on first page with no sorting or refinements
    return isFirst && !hasCustomSorting && !hasRefinements;
}

/**
* Sets a session cookie with a specified name, value, and expiration time.
*
* @param {string} name - The name of the cookie.
* @param {string} value - The value to be stored in the cookie.
* @param {number} hours - The number of hours until the cookie expires.
*/
function setRefinementSessionCookie(name, value, hours) {
    const date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

/**
* Retrieves the value of a specified cookie from the document's cookies.
* 
* @param {string} name - The name of the cookie to retrieve.
* @returns {string|null} The value of the cookie if found, otherwise null.
*/
function getRefinementSessionCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

/**
* Applies search filters based on a cookie value and updates the search results via an AJAX request.
*
* @param {Object} context - The context in which the filter is applied, typically a DOM element.
* @param {string} filterCookieValue - The value of the filter to be applied, retrieved from a cookie.
*/
function applyFiltersBasedOnCookie(context, filterCookieValue) {
    $.spinner().start();
    $(context).trigger("search:filter");
    setRefinementSessionCookie("filterCookie", filterCookieValue, 2);

    var sampleUrl = $(".refinement").find(".card-body").find("button").attr("data-href");
    if (sampleUrl) {
        var preUrlPart = sampleUrl.split("Search-ShowAjax?")[0];
    }
    var dataUrl = preUrlPart + "Search-ShowAjax?" + filterCookieValue;
    $.ajax({
        url: dataUrl,
        data: {
            page: $(".grid-footer").data("page-number"),
            selectedUrl: dataUrl
        },
        method: "GET",
        success: function (response) {
            parseResults(response);
            // initialize product tile custom js functionality
            productTile.init();
            $.spinner().stop();
            $('.search-results-container').css('visibility', 'visible');
        },
        error: function () {
            $.spinner().stop();
            $('.search-results-container').css('visibility', 'visible');
        }
    });
}

/**
* Applies selection based on the value of an article tab cookie and a page query value.
* If the query value from the cookie matches the page query value, it will show or hide
* the search results container based on the cookie's "value" parameter.
*
* @param {string} articleTabCookieValue - The value of the article tab cookie, expected to be a query string.
* @param {string} pageQueryValue - The current page's query value to compare against the cookie's query value.
*/
function applySelectionBasedOnArticleCookie(articleTabCookieValue, pageQueryValue) {
    const paramsArticleTabCookie = new URLSearchParams(articleTabCookieValue);
    const articleCookieQueryValue = paramsArticleTabCookie.get("q");

    if (pageQueryValue == articleCookieQueryValue) {
        const articleCookieShow = paramsArticleTabCookie.get("value");
        if (articleCookieShow == "show") {
            $(".content-search").click();
            $('.search-results-container').css('visibility', 'visible');
        } else {
            $('.search-results-container').css('visibility', 'visible');
        }
    } else {
        $('.search-results-container').css('visibility', 'visible');
    }

}

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $(".search-results-container").on("click", "button.filter-results", function () {
            $(".refinement-bar, .modal-background").show();
            $(".refinement-bar").siblings().attr("aria-hidden", true);
            $(".refinement-bar").closest(".row").siblings().attr("aria-hidden", true);
            $(".refinement-bar").closest(".tab-pane.active").siblings().attr("aria-hidden", true);
            $(".refinement-bar").closest(".search-results-container.search-results").siblings().attr("aria-hidden", true);
            $(".refinement-bar .close").focus();
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $(".search-results-container").on("click", ".refinement-bar button.close, .modal-background", function () {
            $(".refinement-bar, .modal-background").hide();
            $(".refinement-bar").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".row").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".tab-pane.active").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".search-results-container.search-results").siblings().attr("aria-hidden", false);
            $(".btn.filter-results").focus();
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $(".refinement-bar, .modal-background").hide();
            $(".refinement-bar").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".row").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".tab-pane.active").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".search-results-container.search-results").siblings().attr("aria-hidden", false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $(".search-results-container").on("change", "[name=sort-order]", function (e) {
            e.preventDefault();

            $.spinner().start();
            $(this).trigger("search:sort", this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: "GET",
                success: function (response) {
                    $(".product-grid").empty().html(response);
                    // initialize product tile custom js functionality
                    productTile.init();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $(".search-results-container").on("click", ".show-more button", function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data("url");
            e.preventDefault();

            $.spinner().start();
            $(this).trigger("search:showMore", e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: "GET",
                success: function (response) {
                    $(".grid-footer").replaceWith(response);
                    updateSortOptions(response);
                    // initialize product tile custom js functionality
                    productTile.init();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $(".search-results-container").on(
            "click",
            ".refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button",
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger("search:filter", e);
                var attributeId = "#" + $(this).find("span").last().attr("id");
                if ($(this).data("href")) {
                    var filterData = $(this).data("href").split("Search-ShowAjax?")[1];
                    setRefinementSessionCookie("filterCookie", filterData, 2);
                }
                $.ajax({
                    url: $(this).data("href"),
                    data: {
                        page: $(".grid-footer").data("page-number"),
                        selectedUrl: $(this).data("href")
                    },
                    method: "GET",
                    success: function (response) {
                        parseResults(response);
                        // initialize product tile custom js functionality
                        productTile.init();
                        $.spinner().stop();
                        $(attributeId).parent("button").focus();
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent("button").focus();
                    }
                });
            });
    },

    showContentTab: function () {
        // Display content results from the search
        $(".search-results-container").on("click", ".content-search", function () {
            if ($("#content-search-results").html() === "") {
                getContent($(this), $("#content-search-results"));
            }

            const element = document.querySelector(".page");
            const queryString = element.getAttribute("data-querystring");
            const paramsQueryString = new URLSearchParams(queryString);
            const pageQuery = paramsQueryString.get("q");
            
            setRefinementSessionCookie("articleTab", "q=" + pageQuery +"&value=show", 2);
        });

        // Display the next page of content results from the search
        $(".search-results-container").on("click", ".show-more-content button", function () {
            getContent($(this), $("#content-search-results"));
            $(".show-more-content").remove();
        });
    },

    showProductPagination: function () {
        $(document).on("click", ".js-pagination-button", function (e) {
            e.preventDefault();
            var $target = $(e.currentTarget);
            var url = $target.data("url");

            // do nothing if the url is not found
            if (!url) {
                return;
            }

            $.spinner().start();
            $(this).trigger("search:showMore", e);
            $.ajax({
                url: url,
                method: "GET",
                success: function (response) {
                    $(".product-grid").empty().html(response);
                    updateSortOptions(response);
                    
                    // Restore teasers if navigating back to page 1
                    if (isFirstPage(url)) {
                        setTimeout(function() {
                            restoreTeasers();
                        }, 50);
                    }
                    
                    // initialize product tile custom js functionality
                    //productTile.init();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    /**
    * Applies filter settings from the session cookie to the current search results page.
    * If the filter settings in the session cookie match the current page's category ID (cgid),
    * it triggers a search filter event, updates the session cookie, and makes an AJAX request
    * to fetch and display the filtered search results.
    *
    * @function
    * @returns {void}
    */
    applyFilterFromSession: function () {
        const element = document.querySelector(".page");
        const queryString = element.getAttribute("data-querystring");
        const paramsQueryString = new URLSearchParams(queryString);
        const pageCgid = paramsQueryString.get("cgid");
        const pageQueryValue = paramsQueryString.get("q");
        var filterCookieValue = getRefinementSessionCookie("filterCookie");
        var articleTabCookieValue = getRefinementSessionCookie("articleTab");

        if (pageCgid != null) {
            // category page
            if (filterCookieValue != null) {
                const paramsFilterCookie = new URLSearchParams(filterCookieValue);
                const filterCookieCgid = paramsFilterCookie.get("cgid");

                if (pageCgid == filterCookieCgid) {
                    applyFiltersBasedOnCookie(this, filterCookieValue);
                } else {
                    $('.search-results-container').css('visibility', 'visible');
                }
            } else {
                $('.search-results-container').css('visibility', 'visible');
            }

        } else if (pageQueryValue != null) {
            // query page

            var productSearchElement = document.querySelector(".product-search");
            var isActive = productSearchElement && productSearchElement.classList.contains("active");

            // Check if there is no element with the class 'refinement-bar'
            var refinementBarElement = document.querySelector(".refinement-bar");
            var isRefinementBarAbsent = !refinementBarElement;

            // If both conditions are met - products not present, switch to article tab
            if (isActive && isRefinementBarAbsent) {
                $(".content-search").click();
                $('.search-results-container').css('visibility', 'visible');
            } else {
                // products present on query page

                if (articleTabCookieValue == null && filterCookieValue == null) {

                    $('.search-results-container').css('visibility', 'visible');

                } else if (articleTabCookieValue != null && filterCookieValue == null) {

                    applySelectionBasedOnArticleCookie(articleTabCookieValue, pageQueryValue);

                } else if (filterCookieValue != null && articleTabCookieValue == null) {

                    const paramsFilterCookie = new URLSearchParams(filterCookieValue);
                    const filterCookieQueryValue = paramsFilterCookie.get("q");
                    if (pageQueryValue == filterCookieQueryValue) {
                        applyFiltersBasedOnCookie(this, filterCookieValue);
                    } else {
                        $('.search-results-container').css('visibility', 'visible');
                    }

                } else {
                    // both cookie values are present
                    const paramsArticleTabCookie = new URLSearchParams(articleTabCookieValue);
                    const articleCookieQueryValue = paramsArticleTabCookie.get("q");
                
                    if (pageQueryValue == articleCookieQueryValue) {
                        const articleCookieShow = paramsArticleTabCookie.get("value");
                        if (articleCookieShow == "show") {
                            $(".content-search").click();
                            $('.search-results-container').css('visibility', 'visible');
                        } else {
                            // filter query logic
                            const paramsFilterCookie = new URLSearchParams(filterCookieValue);
                            const filterCookieQueryValue = paramsFilterCookie.get("q");
                            if (pageQueryValue == filterCookieQueryValue) {
                                applyFiltersBasedOnCookie(this, filterCookieValue);
                            } else {
                                $('.search-results-container').css('visibility', 'visible');
                            }
                        }
                    } else {
                        // filter query logic
                        const paramsFilterCookie = new URLSearchParams(filterCookieValue);
                        const filterCookieQueryValue = paramsFilterCookie.get("q");
                        if (pageQueryValue == filterCookieQueryValue) {
                            applyFiltersBasedOnCookie(this, filterCookieValue);
                        } else {
                            $('.search-results-container').css('visibility', 'visible');
                        }
                    }

                }
            }
        } else {
            $('.search-results-container').css('visibility', 'visible');
        }
    },

    showProductTab: function () {
        $(".search-results-container").on("click", ".product-search", function () {
            const element = document.querySelector(".page");
            const queryString = element.getAttribute("data-querystring");
            const paramsQueryString = new URLSearchParams(queryString);
            const pageQuery = paramsQueryString.get("q");
            var filterCookieValue = getRefinementSessionCookie("filterCookie");
            setRefinementSessionCookie("articleTab", "q=" + pageQuery +"&value=hide", 2);

            const paramsFilterCookie = new URLSearchParams(filterCookieValue);
            const filterCookieQueryValue = paramsFilterCookie.get("q");

            if (pageQuery == filterCookieQueryValue) {
                applyFiltersBasedOnCookie(this, filterCookieValue);
            } else {
                $('.search-results-container').css('visibility', 'visible');
            }


        });
    },

    captureTeasers: captureTeasers
};
